import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/instance";
import { endpoints } from "../../constants/endpoints";

export const changePasswordAPI = createAsyncThunk(
    "changePasswordAPI",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(endpoints.changePassword(), data)
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

const initialState = {
    loading: false,
}

const ChnagePasswordSlice = createSlice({
    initialState,
    name: "ChnagePasswordSlice",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(changePasswordAPI.pending, (state, action) => {
            state.loading = true
        })

        builder.addCase(changePasswordAPI.fulfilled, (state, action) => {
            state.loading = false
        })

        builder.addCase(changePasswordAPI.rejected, (state, action) => {
            state.loading = false
        })
    }
})

export const { } = ChnagePasswordSlice.actions
export default ChnagePasswordSlice.reducer